"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrisRtcEngine = exports.IrisIntervalType = void 0;
const NATIVE_RTC = __importStar(require("@iris/native-rtc"));
const iris_web_core_1 = require("iris-web-core");
const AgoraMediaBaseDispatch_1 = require("../binding/AgoraMediaBaseDispatch");
const IAgoraH265TranscoderDispatch_1 = require("../binding/IAgoraH265TranscoderDispatch");
const IAgoraMediaPlayerDispatch_1 = require("../binding/IAgoraMediaPlayerDispatch");
const IAgoraMediaRecorderDispatch_1 = require("../binding/IAgoraMediaRecorderDispatch");
const IAgoraMusicContentCenterDispatch_1 = require("../binding/IAgoraMusicContentCenterDispatch");
const IAgoraRtcEngineDispatch_1 = require("../binding/IAgoraRtcEngineDispatch");
const IAgoraRtcEngineExDispatch_1 = require("../binding/IAgoraRtcEngineExDispatch");
const IAgoraSpatialAudioDispatch_1 = require("../binding/IAgoraSpatialAudioDispatch");
const IAudioDeviceManagerDispatch_1 = require("../binding/IAudioDeviceManagerDispatch");
const IrisAgoraEventHandler_1 = require("../event_handler/IrisAgoraEventHandler");
const IAgoraMediaEngineExtensions_1 = require("../extensions/IAgoraMediaEngineExtensions");
const IAgoraRtcEngineExtensions_1 = require("../extensions/IAgoraRtcEngineExtensions");
const ClientHelper_1 = require("../helper/ClientHelper");
const DomHelper_1 = require("../helper/DomHelper");
const ImplHelper_1 = require("../helper/ImplHelper");
const TrackHelper_1 = require("../helper/TrackHelper");
const IrisGlobalState_1 = require("../state/IrisGlobalState");
const AgoraConsole_1 = require("../util/AgoraConsole");
const ErrorHandler_1 = __importDefault(require("../util/ErrorHandler"));
// GEN-153: extension virtual background (blur + image).
// Registrata una volta nel constructor dopo che AgoraRTC è assegnato allo
// globalState. L'impl di enableVirtualBackground usa questa istanza per
// createProcessor() sul track camera locale.
const agora_extension_virtual_background_1 = __importDefault(require("agora-extension-virtual-background"));
const IrisClientManager_1 = require("./IrisClientManager");
var IrisIntervalType;
(function (IrisIntervalType) {
    IrisIntervalType[IrisIntervalType["enableAudioVolumeIndication"] = 0] = "enableAudioVolumeIndication";
    IrisIntervalType[IrisIntervalType["networkQuality"] = 1] = "networkQuality";
})(IrisIntervalType || (exports.IrisIntervalType = IrisIntervalType = {}));
class IrisRtcEngine {
    constructor(irisEventHandlerManager, options) {
        this.implDispatchesMap = new Map();
        this.implHelper = new ImplHelper_1.ImplHelper(this);
        this.trackHelper = new TrackHelper_1.TrackHelper(this);
        this.clientHelper = new ClientHelper_1.ClientHelper(this);
        this.irisClientManager = new IrisClientManager_1.IrisClientManager(this);
        this.irisIntervalList = [];
        this.irisRtcErrorHandler = new ErrorHandler_1.default(this);
        const mapData = [
            ['MediaPlayer', new IAgoraMediaPlayerDispatch_1.IMediaPlayerDispatch(this)],
            ['MediaPlayerCacheManager', new IAgoraMediaPlayerDispatch_1.IMediaPlayerCacheManagerDispatch(this)],
            ['MediaEngine', new IAgoraMediaEngineExtensions_1.MediaEngineDispatchExtensions(this)],
            ['MediaRecorder', new IAgoraMediaRecorderDispatch_1.IMediaRecorderDispatch(this)],
            ['MusicChartCollection', new IAgoraMusicContentCenterDispatch_1.MusicChartCollectionDispatch(this)],
            ['MusicCollection', new IAgoraMusicContentCenterDispatch_1.MusicCollectionDispatch(this)],
            ['MusicPlayer', new IAgoraMusicContentCenterDispatch_1.IMusicPlayerDispatch(this)],
            ['H265Transcoder', new IAgoraH265TranscoderDispatch_1.IH265TranscoderDispatch(this)],
            ['MusicContentCenter', new IAgoraMusicContentCenterDispatch_1.IMusicContentCenterDispatch(this)],
            ['AudioDeviceManager', new IAudioDeviceManagerDispatch_1.IAudioDeviceManagerDispatch(this)],
            ['VideoDeviceManager', new IAgoraRtcEngineDispatch_1.IVideoDeviceManagerDispatch(this)],
            ['RtcEngine', new IAgoraRtcEngineExtensions_1.RtcEngineDispatchExtensions(this)],
            ['RtcEngineEx', new IAgoraRtcEngineExDispatch_1.IRtcEngineExDispatch(this)],
            ['VideoFrameMetaInfo', new AgoraMediaBaseDispatch_1.IVideoFrameMetaInfoDispatch(this)],
            ['LocalSpatialAudioEngine', new IAgoraSpatialAudioDispatch_1.ILocalSpatialAudioEngineDispatch(this)],
        ];
        mapData.forEach(([key, value]) => this.implDispatchesMap.set(key, value));
        this.rtcEngineEventHandler = new IAgoraRtcEngineDispatch_1.IRtcEngineEventHandler(this);
        this.mediaEngineEventHandler = new AgoraMediaBaseDispatch_1.IAudioFrameObserver(this);
        this.globalState = new IrisGlobalState_1.IrisGlobalState();
        this.irisElement = new DomHelper_1.IrisElement();
        this.agoraEventHandler = new IrisAgoraEventHandler_1.IrisAgoraEventHandler(this);
        this.executor = new iris_web_core_1.CallApiExecutor(true);
        this.irisEventHandlerManager = irisEventHandlerManager;
        if (options && options.agoraRTC) {
            AgoraConsole_1.AgoraConsole.debug('use agoraRTC from initIrisRtc');
            this.globalState.AgoraRTC = options.agoraRTC;
        }
        // GEN-153: registra virtual background extension UNA VOLTA a livello
        // globale. registerExtensions è idempotente? No: va chiamato una volta.
        // Guard try/catch perché in ambiente test (jest-jsdom) registerExtensions
        // può fallire per browser checks (checkCompatibility richiede WebAssembly
        // e canvas.captureStream). L'extension e processor sono lazy-created
        // nell'impl al primo enableVirtualBackground.
        try {
            const ext = new agora_extension_virtual_background_1.default();
            this.globalState.AgoraRTC.registerExtensions([ext]);
            this.globalState.virtualBackgroundExtension = ext;
            AgoraConsole_1.AgoraConsole.debug('[VirtualBg] extension registered');
        }
        catch (e) {
            AgoraConsole_1.AgoraConsole.warn(`[VirtualBg] registerExtensions failed: ${e}`);
        }
    }
    intercept(apiParam) {
        return this.callIrisApiAsync(apiParam);
    }
    callIrisApiAsync(apiParam) {
        return __awaiter(this, void 0, void 0, function* () {
            let func_name = apiParam.event;
            let array = func_name.split('_');
            let className = array[0];
            let funName = array.slice(1).join('_');
            AgoraConsole_1.AgoraConsole.log(`[callIrisApiAsync][start] ${(() => {
                let printData = JSON.parse(JSON.stringify(apiParam));
                printData === null || printData === void 0 ? true : delete printData.buffer;
                return JSON.stringify(printData);
            })()}`);
            let obj = this.implDispatchesMap.get(className);
            if (obj) {
                let callApiFun = obj[funName];
                if (callApiFun) {
                    if (func_name !== 'RtcEngine_initialize_0320339' &&
                        this.irisClientManager.irisClientList.length == 0) {
                        AgoraConsole_1.AgoraConsole.error('you have not initialize yet');
                        return new iris_web_core_1.CallIrisApiResult(-NATIVE_RTC.ERROR_CODE_TYPE.ERR_NOT_INITIALIZED, '');
                    }
                    let ret = yield callApiFun.call(obj, apiParam);
                    AgoraConsole_1.AgoraConsole.log(`[callIrisApiAsync][result] ${func_name} ret ${ret.code}`);
                    return ret;
                }
                else {
                    AgoraConsole_1.AgoraConsole.error(`[callIrisApiAsync][result] ${func_name} not found in ${className}Dispatch`);
                    // TODO(guoxianze): Temporarily return ERR_NOT_SUPPORTED, for not implemented api.
                    return this.returnResult(false, -NATIVE_RTC.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
                }
            }
            else {
                AgoraConsole_1.AgoraConsole.error(`[callIrisApiAsync][result] ${className} not found in DispatchsMap`);
                // TODO(guoxianze): Temporarily return ERR_NOT_SUPPORTED, for not implemented module.
                return this.returnResult(false, -NATIVE_RTC.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
            }
        });
    }
    getImplInstance(className) {
        var _a;
        return (_a = this.implDispatchesMap.get(className)) === null || _a === void 0 ? void 0 : _a._impl;
    }
    getVideoFrame(uid, channel_id) {
        return this.irisClientManager.getVideoFrame(uid, channel_id);
    }
    getVideoFrameByConfig(config) {
        return this.irisClientManager.getVideoFrameByConfig(config);
    }
    execute(task) {
        return this.executor.execute(task);
    }
    returnResult(isSuccess = true, code, data = '{"result": 0}') {
        if (isSuccess) {
            code = NATIVE_RTC.ERROR_CODE_TYPE.ERR_OK;
        }
        else {
            if (typeof code !== 'number') {
                code = -NATIVE_RTC.ERROR_CODE_TYPE.ERR_FAILED;
            }
        }
        return Promise.resolve(new iris_web_core_1.CallIrisApiResult(code, data));
    }
    release() {
        return __awaiter(this, void 0, void 0, function* () {
            this.agoraEventHandler.release();
            yield this.irisClientManager.release();
        });
    }
    addIrisInterval(type, interval, uid) {
        //如果添加的是远端用户的轮询,uid用远端的
        //如果添加的是本地用户的轮询,uid固定为0
        this.irisIntervalList.push({
            type,
            interval,
            uid,
        });
    }
    getIrisIntervalByType(type) {
        this.irisIntervalList.filter((a) => type == a.type);
    }
    removeIrisIntervalByUid(uid) {
        for (let i = 0; i < this.irisIntervalList.length; i++) {
            let item = this.irisIntervalList[i];
            if (item.uid == uid) {
                item.interval && clearInterval(item.interval);
                this.irisIntervalList.splice(i, 1);
                break;
            }
        }
    }
    removeIrisIntervalByType(type) {
        for (let i = 0; i < this.irisIntervalList.length; i++) {
            let item = this.irisIntervalList[i];
            if (item.type == type) {
                item.interval && clearInterval(item.interval);
                this.irisIntervalList.splice(i, 1);
                i--;
            }
        }
    }
    clearIrisInterval() {
        this.irisIntervalList.map((item) => {
            AgoraConsole_1.AgoraConsole.debug(`clear interval`);
            item.interval && clearInterval(item.interval);
        });
    }
    dispose() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.release();
            return Promise.resolve();
        });
    }
}
exports.IrisRtcEngine = IrisRtcEngine;
